export class PearlHarborGameConfig {
    public static totalReels: number = 7;
    public static totalSymsPerReel: number = 7;
    public static defaultGameAreaSize: number[] = [PearlHarborGameConfig.totalSymsPerReel, PearlHarborGameConfig.totalSymsPerReel, PearlHarborGameConfig.totalSymsPerReel, PearlHarborGameConfig.totalSymsPerReel, PearlHarborGameConfig.totalSymsPerReel, PearlHarborGameConfig.totalSymsPerReel, PearlHarborGameConfig.totalSymsPerReel];
    public static reelViewTop: number = 90;
    public static reelViewLeft: number = -18;
    public static symbolWidth: number = 125;
    public static symbolHeight: number = 96;

    public static MAIN_REELS_VIEW_MASK_POSITION: PIXI.Point = new PIXI.Point(0, 0);

    public static reelPositions: PIXI.Point[] = [
        new PIXI.Point(0, 0),
        new PIXI.Point(PearlHarborGameConfig.symbolWidth, 0),
        new PIXI.Point(PearlHarborGameConfig.symbolWidth * 2, 0),
        new PIXI.Point(PearlHarborGameConfig.symbolWidth * 3, 0),
        new PIXI.Point(PearlHarborGameConfig.symbolWidth * 4, 0),
        new PIXI.Point(PearlHarborGameConfig.symbolWidth * 5, 0),
        new PIXI.Point(PearlHarborGameConfig.symbolWidth * 6, 0)
    ];

    public static rowPositions: PIXI.Point[] = [
        new PIXI.Point(0, 0),
        new PIXI.Point(0, PearlHarborGameConfig.symbolHeight),
        new PIXI.Point(0, PearlHarborGameConfig.symbolHeight * 2),
        new PIXI.Point(0, PearlHarborGameConfig.symbolHeight * 3),
        new PIXI.Point(0, PearlHarborGameConfig.symbolHeight * 4),
        new PIXI.Point(0, PearlHarborGameConfig.symbolHeight * 5),
        new PIXI.Point(0, PearlHarborGameConfig.symbolHeight * 6)
    ];

    public static reelSpinStartSymbolDelay: number = 0.03;

    public static stepDuration: number = 0.06;
    public static reelAllOutStopDelay: number = PearlHarborGameConfig.stepDuration;
    public static reelAllOutStopDelayFastSpin: number = PearlHarborGameConfig.stepDuration * 0.5;

    public static reelAllInStopDelayFastSpin: number = PearlHarborGameConfig.stepDuration * 0.5;
    public static reelAllInStopDelay: number = PearlHarborGameConfig.stepDuration;

    public static reelSpinStopSymbolDelay: number = 0.05;
    public static reelSpinStopNearWinDelay: number = 1;
    public static TOTAL_WIN_VIEW_POSITION: PIXI.Point = new PIXI.Point(0, 0);
    public static PORTRAIT_Y_OFFSET: number = 360;
    public static LAYERS = {
        ACTIVE_AREA: "ACTIVE_AREA",
        OVERLAY: "Overlay",
        MULTIPLIER: "Multiplier",
        SCATTER_COUNTER: "ScatterCounter",
        BOOST_BET: "BoostBet",
        WAYS_WON: "WaysWon",
        SPEEDSTER: "SPEEDSTER",
        XS_ANIMATION: "XSplitAnimation",
        MAINGAME_FRAME: "MainGameFrame",
        HIT_CHANCE: "HitChance"
    };
    public static wagonMoveDuration: number = 0.1;
    public static quickSpinWagonMoveDuration: number = 0.05;
    public static scatterMoveDuration: number = 0.35;
    public static quickSpinScatterMoveDuration: number = 0.2;
    public static collectableMultiplierMoveDuration: number = 0.15;

    //All in total spin time
    public static mainAllInTotalSpinDuration: number = 0.29;
    public static mainAllInTotalSpinDurationFastSpin: number = 0.2;

    //Spin-in gap between symbols
    public static mainReelSpinStopSymbolDelayFastSpin: number = 0.02;
    public static mainReelSpinStopSymbolDelay: number = 0.04;

    //Blur delay, all in
    public static mainReelAllInBlurDelayFastSpin: number = 0.010;
    public static mainReelAllInBlurDelay: number = 0.22;
}